import React from "react"

export const NextIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    viewBox="0 0 31 31"
  >
    <g id="arrow" transform="translate(31 31) rotate(180)">
      <g id="arrow-2" data-name="arrow" transform="translate(9.58 8)">
        <path
          id="Path_14617"
          data-name="Path 14617"
          d="M60.8,7.09h0L67.553.342a1.168,1.168,0,1,1,1.652,1.652L63.284,7.916l5.922,5.923a1.168,1.168,0,1,1-1.652,1.652L60.8,8.743a1.168,1.168,0,0,1,0-1.652"
          transform="translate(-60.462)"
          fill="#626b5d"
        />
        <path
          id="Path_14618"
          data-name="Path 14618"
          d="M.343,85.616h0l3.593-3.593a1.168,1.168,0,0,1,1.652,1.652L2.822,86.442,5.6,89.222a1.168,1.168,0,0,1-1.652,1.652L.343,87.269a1.168,1.168,0,0,1,0-1.652"
          transform="translate(5.477 -78.526)"
          fill="#626b5d"
        />
      </g>
      <path
        id="Ellipse_6"
        data-name="Ellipse 6"
        d="M15.5,2A13.5,13.5,0,0,0,5.954,25.046,13.5,13.5,0,1,0,25.046,5.954,13.412,13.412,0,0,0,15.5,2m0-2A15.5,15.5,0,1,1,0,15.5,15.5,15.5,0,0,1,15.5,0Z"
        fill="#626b5d"
      />
    </g>
  </svg>
)

export const PreviousIcon = () => (
  <svg
    id="arrow"
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    viewBox="0 0 31 31"
  >
    <g id="arrow-2" data-name="arrow" transform="translate(9.58 8)">
      <path
        id="Path_14617"
        data-name="Path 14617"
        d="M60.8,7.09h0L67.553.342a1.168,1.168,0,1,1,1.652,1.652L63.284,7.916l5.922,5.923a1.168,1.168,0,1,1-1.652,1.652L60.8,8.743a1.168,1.168,0,0,1,0-1.652"
        transform="translate(-60.462)"
        fill="#626b5d"
      />
      <path
        id="Path_14618"
        data-name="Path 14618"
        d="M.343,85.616h0l3.593-3.593a1.168,1.168,0,0,1,1.652,1.652L2.822,86.442,5.6,89.222a1.168,1.168,0,0,1-1.652,1.652L.343,87.269a1.168,1.168,0,0,1,0-1.652"
        transform="translate(5.477 -78.526)"
        fill="#626b5d"
      />
    </g>
    <path
      id="Ellipse_6"
      data-name="Ellipse 6"
      d="M15.5,2A13.5,13.5,0,0,0,5.954,25.046,13.5,13.5,0,1,0,25.046,5.954,13.412,13.412,0,0,0,15.5,2m0-2A15.5,15.5,0,1,1,0,15.5,15.5,15.5,0,0,1,15.5,0Z"
      fill="#626b5d"
    />
  </svg>
)
